import { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Button, Form, Grid, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useCurrentUser from '@hooks/useCurrentUser'
import useProvider, { useProviderForm } from '@hooks/useProvider'

const ManageProviderApiSettingsModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, updateProvider } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { provider } = modalPayload

  const {
    callbacks: { updateProvider: updateFn },
    updating,
  } = useProvider(provider)

  const providerFormPayload = useProviderForm(provider)
  const {
    entityState,
    entityState: {
      options: {
        order_api_endpoint,
        pricing_api,
        slack_booking_updates_webhook_url,
        slack_project_comments_webhook_url,
        slack_task_updates_webhook_url,
      },
      order_api,
    },
    handlers,
  } = providerFormPayload

  const updateProviderPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'API Settings Updated',
  }

  const { isAdmin } = useCurrentUser()

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="API" titleSecondLine="Settings" />

      <SidebarModal.Content>
        <Grid gridRowGap="large">
          {isAdmin && (
          <>
            <Form.Field direction="column" label="Order API">
              <select name="order_api" value={order_api} {...handlers}>
                <option value="">None</option>
                <option value="abc_photosigns">ABC Photosigns</option>
                <option value="briner">Briner</option>
                <option value="printco">Printco</option>
                <option value="vfx">VFX</option>
              </select>
            </Form.Field>

            <Form.Field direction="column" label="Pricing API">
              <select name="options.pricing_api" value={pricing_api} {...handlers}>
                <option value="">None</option>
                <option value="domain_group_suburb_pricing">Domain Suburb Pricing (API)</option>
                <option value="provider_zone_pricing">Provider Zone Pricing</option>
                <option value="rea_suburb_pricing_api">REA Suburb Pricing (API)</option>
                <option value="rea_suburb_pricing">REA Suburb Pricing (Deprecated)</option>
              </select>
            </Form.Field>
          </>
          )}

          {order_api === 'abc_photosigns' && (
          <Form.Field label="Order API Endpoint">
            <input
              name="options.order_api_endpoint"
              placeholder="Leave empty for default"
              type="text"
              value={order_api_endpoint}
              {...handlers}
            />
          </Form.Field>
          )}

          <Form.Field label="Slack Project Comments">
            <input
              name="options.slack_project_comments_webhook_url"
              value={slack_project_comments_webhook_url}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Slack Task Completions">
            <input
              name="options.slack_task_updates_webhook_url"
              value={slack_task_updates_webhook_url}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Slack Booking Completions">
            <input
              name="options.slack_booking_updates_webhook_url"
              value={slack_booking_updates_webhook_url}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Grid>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updateProvider(updateProviderPayload)}
          size="large"
        >
          Save API Settings
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

ManageProviderApiSettingsModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

ManageProviderApiSettingsModal.defaultProps = {
  modalKey: 'ManageProviderApiSettingsModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <ManageProviderApiSettingsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
